import { devSimulatePing } from '~/rage/decorators';
import {
	IEntitySearchService,
	IPlayerSearchResult,
} from './entitySearchServiceTypes';

export class EntitySearchServiceStub implements IEntitySearchService {
	private players = [
		{ characterId: 'player-1', nickname: 'BeautifulPotato12' },
		{ characterId: 'player-2', nickname: 'Wherry' },
		{ characterId: 'player-3', nickname: 'AwesomeGamer' },
		{ characterId: 'player-4', nickname: 'CodeMaster' },
		{ characterId: 'player-5', nickname: 'NinjaPlayer' },
		{ characterId: 'player-6', nickname: 'PlayerX' },
		{ characterId: 'player-7', nickname: 'GamingLegend' },
		{ characterId: 'player-8', nickname: 'ProGamer123' },
		{ characterId: 'player-9', nickname: 'MasterCoder' },
		{ characterId: 'player-10', nickname: 'SuperPlayer' },
		{ characterId: 'player-11', nickname: 'EpicGamer' },
		{ characterId: 'player-12', nickname: 'Player123' },
		{ characterId: 'player-13', nickname: 'TheGamingOne' },
		{ characterId: 'player-14', nickname: 'CodingNinja' },
		{ characterId: 'player-15', nickname: 'PlayerXtreme' },
		{ characterId: 'player-16', nickname: 'GamerGirl' },
		{ characterId: 'player-17', nickname: 'CodeWizard' },
		{ characterId: 'player-18', nickname: 'ProPlayer' },
		{ characterId: 'player-19', nickname: 'TheMasterGamer' },
		{ characterId: 'player-20', nickname: 'Player1234' },
	];

	@devSimulatePing()
	public async findOnlinePlayerByNickname(
		nickname: string,
	): Promise<IPlayerSearchResult[]> {
		await new Promise((resolve) =>
			setTimeout(resolve, 200 + Math.random() * 300),
		);

		return Promise.resolve(
			this.players
				.filter((player) => player.nickname.includes(nickname))
				.map((player) => ({
					characterId: player.characterId,
					nickname: player.nickname,
				})),
		);
	}

	public async findNearbyPlayers(): Promise<IPlayerSearchResult[]> {
		return this.players.slice(0, 6).map((player) => ({
			characterId: player.characterId,
			nickname: player.nickname,
		}));
	}

	public async findPlayerNicknameByCharacterId(
		characterId: string,
	): Promise<string | null> {
		return (
			this.players.find((player) => player.characterId === characterId)
				?.nickname ?? null
		);
	}
}
